export const brl = (n) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(n || 0));

export const fmtDate = (iso) => {
  if (!iso) return "";
  // Parse directly from ISO string "YYYY-MM-DD" to avoid UTC timezone shift
  const parts = iso.split("-");
  if (parts.length >= 3) {
    return `${parts[2].slice(0, 2)}/${parts[1]}`;
  }
  // Fallback for other formats
  const d = new Date(iso + "T12:00:00");
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const filterByMonth = (items, ym) => items.filter((it) => (it.data || "").startsWith(ym));
export const sumValor = (items) => items.reduce((s, it) => s + Number(it.valor || 0), 0);

export const fmtMonth = (n) =>
  ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"][n];

export const fmtMonthLong = (ym) => {
  if (!ym) return "";
  const [y, m] = ym.split("-");
  const names = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
  return `${names[parseInt(m,10)-1]} de ${y}`;
};
